export default {"src":"/_next/static/media/docs-post.ae40f785.svg","height":345,"width":578};